var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.rowData["changeSupplierName"] !== _vm.rowData["supplierName"]
      ? _c("span", [
          _c("p", { staticClass: "parse36" }, [
            _c("span", { staticClass: "title actual" }, [_vm._v("实")]),
            _vm._v(_vm._s(_vm.rowData["changeSupplierName"])),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "parse36" }, [
            _c("span", { staticClass: "title recommend" }, [_vm._v("荐")]),
            _vm._v(_vm._s(_vm.rowData["supplierName"])),
          ]),
        ])
      : _c("span", [
          _c("p", { staticClass: "parse36" }, [
            _vm._v(_vm._s(_vm.rowData["supplierName"])),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }